export default {
  userLockedManually: 'The user is locked manually',
  userLocked: 'The user is locked',
  userAutoLockedStart: 'The user is autolocked. ',
  userAutoLockedEnd: 'h left.',
  reason: 'Reason: ',
};
